import { Company } from './company.model';

export class GetMetricsMarketingTotalOfUserCompaniesResponse {
  companies: Company[];

  constructor(companies: Company[]) {
    this.companies = companies;
  }
}
